import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "./styles/global.scss";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import UndrawUi from "undraw-ui";
import "undraw-ui/dist/style.css";

// 清理历史主题 class / 本地偏好
document.documentElement.classList.remove("dark");
try {
  localStorage.removeItem("theme-mode");
} catch (e) {
  /* ignore */
}

const app = createApp(App);
app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
});
app.use(UndrawUi);

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.mount("#app");
